export default __webpack_public_path__ + "static/media/savep.3d017789.png";